module.exports = __webpack_public_path__ + "static/media/caution.f4861d92.svg";